// extracted by mini-css-extract-plugin
module.exports = {"ContentSummaryGrid":"CBBFCContentSummaryGrid_ContentSummaryGrid__1ssw0","centered":"CBBFCContentSummaryGrid_centered__2f3g7","staggered":"CBBFCContentSummaryGrid_staggered___i_4D"};